
export default function ProjectOverview() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const features = [
    {
      icon: 'ri-building-line',
      title: '8개 필지 통합',
      description: '서초동 1302번지 일대 8개 필지를 합필하여 대규모 복합개발 단지 조성',
      onClick: () => scrollToSection('land-analysis')
    },
    {
      icon: 'ri-home-smile-line',
      title: '하이엔드 레지던스',
      description: '프리미엄급 오피스텔과 최고급 주거 환경을 제공하는 레지던스'
    },
    {
      icon: 'ri-community-line',
      title: '공공기여 시설',
      description: '1-4층 공개공지 및 스마트 시설로 지역사회 기여'
    },
    {
      icon: 'ri-leaf-line',
      title: '친환경 설계',
      description: '지속가능한 생활환경과 친환경 설비를 통한 미래지향적 개발'
    }
  ];

  return (
    <section id="overview" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">프로젝트 개요</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            서초동의 새로운 랜드마크가 될 프리미엄 복합개발 프로젝트입니다.<br />
            혁신적인 설계와 최첨단 시설로 미래형 주거문화를 선도합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-all cursor-pointer group"
              onClick={feature.onClick}
            >
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-teal-600 transition-colors">
                <i className={`${feature.icon} text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">프로젝트 위치 및 규모</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-map-pin-line text-teal-600 text-lg"></i>
                </div>
                <div>
                  <strong className="text-gray-900 block mb-1">위치</strong>
                  <p className="text-gray-600">서울특별시 서초구 서초동 1302번지 일대</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-layout-grid-line text-teal-600 text-lg"></i>
                </div>
                <div>
                  <strong className="text-gray-900 block mb-1">개발 규모</strong>
                  <p className="text-gray-600">8개 필지 통합 대규모 복합개발</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-building-2-line text-teal-600 text-lg"></i>
                </div>
                <div>
                  <strong className="text-gray-900 block mb-1">건물 구성</strong>
                  <p className="text-gray-600">지상 8층 이상 프리미엄 복합시설</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-star-line text-teal-600 text-lg"></i>
                </div>
                <div>
                  <strong className="text-gray-900 block mb-1">특징</strong>
                  <p className="text-gray-600">스마트 홈 시스템 및 고급 커뮤니티 시설 완비</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/71e6c464a2fe94ce5719cbaabf6b70f0.jpg" 
              alt="프로젝트 위치" 
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}